export default __webpack_public_path__ + "static/media/timelineicon.6faaec7e.svg";